import React from 'react';
import { Drawer, Button, Panel, Divider, Tag, Stack } from 'rsuite';
import { Icon } from '@rsuite/icons';
import { MdPerson } from 'react-icons/md';
import { useTranslation } from 'react-i18next';


interface DetailsDrawerProps {
  open: boolean;
  onClose: () => void;
  data: any;
}

const DetailsDrawer = ({ open, onClose, data }: DetailsDrawerProps) => {
  const getStatusColor = (status?: string) => {
    switch (status) {
      case 'accepted':
        return 'green';
      case 'pending':
        return 'yellow';
      case 'refused':
        return 'red';
      default:
        return 'grey';
    }
  };
  const { t } = useTranslation();
  return (
    <Drawer
      backdrop="static"
      size="sm"
      placement="right"
      open={open}
      onClose={onClose}
      style={{
        boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
        borderRadius: '8px'
      }}
    >
      <Drawer.Header>
        <Drawer.Title>{t('Home Office Request Details')}</Drawer.Title>
        <Drawer.Actions>
          <Button onClick={onClose} appearance="primary">
            {t('Close')}
          </Button>
        </Drawer.Actions>
      </Drawer.Header>

      <Drawer.Body>
        <Panel bordered style={{ padding: '16px', borderRadius: '8px' }}>
          <Stack spacing={10}>
            <Icon as={MdPerson} style={{ fontSize: '25px', color: '#3498ff' }} />
            <h5 style={{ margin: 0, color: '#333' }}>
              {`${data?.idSender?.firstname || ''} ${data?.idSender?.lastname || ''}`}
            </h5>
          </Stack>

          <Divider />

          <div style={{ padding: '0 10px', lineHeight: 1.8 }}>
            {[
              {
                label: t('Status'),
                value: (
                  <Tag color={getStatusColor(data?._id?.status)}>
                    {t(data?._id?.status) || 'Unknown'}
                  </Tag>
                )
              },
              {
                label: t('Registration number'),
                value: data?.idSender?.registrationNumber || 'N/A'
              },
              {
                label: t('Email'),
                value: data?.idSender?.Email || 'N/A'
              },
              {
                label: t('Days Requested'),
                value:
                  data?.operations
                    ?.map((op: any) => `${new Date(op.date).toLocaleDateString()} - ${op.timeslot}`)
                    .join(', ') || 'N/A'
              },
              {
                label: t('Created at'),
                value: data?._id?.createdAt ? new Date(data._id.createdAt).toLocaleString() : 'N/A'
              },
              {
                label: t('Validator'),
                value: `${data?.idReciever?.firstname || ''} ${data?.idReciever?.lastname || 'N/A'}`
              },
              {
                label: t('User Notifications'),
                value: data?.UserNotif?.length > 0 
                  ? data.UserNotif.map(user => 
                      typeof user === 'string' 
                        ? user 
                        : `${user?.firstname || ''} ${user?.lastname || 'Unknown User'}`
                    ).join(', ') 
                  : 'N/A'
              },
              {
                label: t('Comments'),
                value: data?.commentUser || 'N/A'
              }
            ].map((item, index) => (
              <div
                key={index}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  padding: '8px 0',
                  borderBottom: index < 3 ? '1px solid #f0f0f0' : 'none'
                }}
              >
                <strong>{item.label}:</strong>
                <span>{item.value}</span>
              </div>
            ))}
          </div>
        </Panel>
      </Drawer.Body>
    </Drawer>
  );
};

export default DetailsDrawer;
